export var ReportType;
(function (ReportType) {
    ReportType["SPECTRUM"] = "spectrumUtilisation";
    ReportType["CERTIFICAT_RAMONAGE"] = "certificatRamonage";
    ReportType["JARDINIER_REPORT"] = "compteRenduJardinier";
})(ReportType || (ReportType = {}));
//# sourceMappingURL=ReportType.js.map